module.exports = __webpack_public_path__ + "img/veterinaris.c7a6189d.png";